/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IActionContext } from '@msdyn365-commerce/core';
import { getFeatureStatesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/StoreOperationsDataActions.g';

export async function isRetailB2BContactMultiOutletOrderingFeatureEnabled(context: IActionContext): Promise<boolean> {
    const featureStates = await getFeatureStatesAsync({ callerContext: context }, [
        'Dynamics.AX.Application.RetailB2BContactMultiOutletOrderingFeature'
    ]);
    return (featureStates.length > 0 && featureStates[0].IsEnabled) ?? false;
}
